import React, { Component } from 'react';
import {
  Field,
  reduxForm,
  change,
  reset
} from 'redux-form';
import { browserHistory } from 'react-router';
import DatePicker from 'react-datepicker';
import Datetime from 'react-datetime';
import moment from 'moment';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { isEmpty, trim } from 'lodash';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import withOnline from '../../common/withOnline';
import withTeam from '../../common/withTeam';
import withUser from '../../common/withUser';
import withSelectCaseDate from '../../common/withSelectCaseDate';
import withSetsListStateStorage from '../../common/withSetsListStateStorage';
import withTableName from '../../common/withTableName';
import withSelectedSetsPayload from '../../common/withSelectedSetsPayload';
import {
  renderField,
  maxLength3,
  maxLength25,
  maxLength50,
  maxValue120
} from '../../helpers/form-validations';
import Header from '../../components/Header';
import {
  onGoBack,
  sortData,
  getNoneAtTop,
  getSelectedDateTime,
  isMobile
} from '../../common/globals';
import {
  getSurgeons,
  getProcedureTypes,
  getTeamReps,
  getSideType,
  getGenderType,
  getHeightUnitType,
  getWeightUnitType,
  updateTableWiseCaseByCaseId,
  getCustomerNoByName,
  insertCaseByCaseId,
  updateCaseByPrimaryId,
  getTableCaseByCaseId,
  getCaseByCaseScheduleID,
  updateCaseByCaseScheduleID,
  getHospitalByCustomerNo,
  getAltCaseTypes,
} from '../../utils/db';
import {
  addCases,
  updateCase,
  listSingleCase,
  // updateACMLog
} from '../../utils/utils';
import Bugsnag from '../../helpers/bugsnag';
import AcmCaseEditNotify from '../../components/Models/AcmCaseEditNotify';
import CaseChangesNoLonger from '../../components/Models/CasesChangesNoLonger';
import TypeChangeConfirmationModal from '../../components/Models/TypeChangeConfirmationModal';
import ACMProductGoBackModal from '../../components/Models/ACMProductGoBackModal';
import TextareaExpanding from '../../components/TextareaExpanding.js';
import ChooseFieldPage from '../../components/ManageCase/ChooseFieldPage.js';
import AcmCaseCancel from '../../components/Models/AcmCaseCancel';

class EditManageCase extends Component {
  constructor(props) {
    super(props);
    // const { team: { timezone } } = this.props;
    this.state = {
      manageCaseData: {},
      fixCaseData: {},
      types: [],
      selectedType: '',
      selectedAltCaseType: '',
      surgeons: [],
      selectedSurgeon: '',
      hospitals: [],
      selectedHospital: '',
      procedures: [],
      selectedProcedure: '',
      sides: [],
      selectedSide: '',
      selectedStartTime: '',
      // selectedCaseDate: new Date(new Date().toLocaleString('en-US', { timeZone: timezone })),
      selectedCaseDate: new Date(new Date().toLocaleString('en-US')),
      genders: [],
      selectedGender: '',
      heightUnitType: [],
      selectedHeightUnit: '',
      weightUnitType: [],
      selectedWeightUnit: '',
      caseData: {},
      isEdit: false,
      selectedCaseId: '',
      coverReps: [],
      selectedCoverRep: '',
      count: 0,
      // selectedCaseTime: new Date(new Date(
      //   new Date().toLocaleString('en-US', { timeZone: timezone })
      // ).setHours(7, 0)),
      selectedCaseTime: new Date(new Date(new Date().toLocaleString('en-US')).setHours(7, 0)),
      customerNo: '',
      RepNotes: '',
      Comments: '',
      fieldPageToShow: null,
      timeConstraints: { minutes: { step: 15 } },
      hospitalUseCustCaseIDStatus: false,
    };
    this.acmCaseEditNotifyModal = null;
    this.caseChangesNoLonger = null;
    this.typeChangeConfirmationModal = null;
    this.manageCaseBackModal = null;
    this.acmCaseCancelModal = null;
  }

  componentDidMount() {
    try {
      const { setSetsListStateStorage, setSelectedSetsPayload } = this.props;
      setSetsListStateStorage({});
      setSelectedSetsPayload([]);
      this.acmCaseEditNotifyModal = new window.bootstrap.Modal(window.$('#acmCaseEditNotifyModal'));
      this.caseChangesNoLonger = new window.bootstrap.Modal(window.$('#CaseChangesNoLongerModal'));
      this.typeChangeConfirmationModal = new window.bootstrap.Modal(window.$('#typeChangeConfirmationModal'));
      this.manageCaseBackModal = new window.bootstrap.Modal(window.$('#acmProductGoBackModal'));
      this.acmCaseCancelModal = new window.bootstrap.Modal(window.$('#AcmCaseCancelModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getHospital = async (value) => {
    try {
      const { surgeons } = this.state;
      const hospitalFilterRes = surgeons.filter((obj) => obj.SurgeonName.toString() === value);
      // const sortHospitals = sortData(hospitalFilterRes, 'CustomerName');
      let hospitalsToReturn = [];
      await Promise.all(hospitalFilterRes.map(async (hospital) => {
        const tempHospitals = hospital.surgeon_hospitals;
        const customerNosRes = [];
        tempHospitals.forEach((obj) => {
          customerNosRes.push(obj.CustomerNo);
        });
        let newData = [];
        await Promise.all(customerNosRes.map(async (item) => {
          const hospitalRes = await getHospitalByCustomerNo(item);
          if (!isEmpty(hospitalRes)) {
            newData.push(hospitalRes);
            const filtered = [];
            for (let i = 0; i < newData.length; i++) {
              let isHasNotEqual = true;
              for (let j = 0; j < filtered.length; j++) {
                if (filtered[j].CustomerNo === newData[i].CustomerNo) {
                  isHasNotEqual = false;
                }
              }
              if (isHasNotEqual) {
                filtered.push(newData[i]);
              }
            }
            newData = filtered;
            this.setState({
              hospitals: sortData(newData, 'CustomerName'),
            });
          }
        }));
        hospitalsToReturn = [...newData];
      }));
      return hospitalsToReturn;
      // hospitalFilterRes.map((hospitalRes) => {
      //   this.setState({
      //     hospitals: sortData(hospitalRes.surgeon_hospitals, 'CustomerName'),
      //   }, () => {
      //     $('#hospitalsEle').select2('open');
      //   });
      // });
    } catch (e) {
      Bugsnag.notify(e);
      return [];
    }
  }

  _getCaseType = async () => {
    try {
      const typeRes = await getAltCaseTypes();
      const sortType = sortData(typeRes, 'AltCaseType');
      this.setState({
        types: sortType
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getSurgeon = async () => {
    try {
      const surgeonRes = await getSurgeons();
      const sortSurgeons = sortData(surgeonRes, 'SurgeonName');
      this.setState({
        surgeons: sortSurgeons
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getProcedureTypes = async () => {
    try {
      const procedureTypesRes = await getProcedureTypes();
      this.setState({
        procedures: procedureTypesRes
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getTeamReps = async () => {
    try {
      const { user: { name } } = this.props;
      const teamRepsRes = await getTeamReps();
      teamRepsRes.push({ SalesRepName: name });
      const seen = new Set();
      const filteredArr = teamRepsRes.filter((el) => {
        if (el.SalesRepName !== '') {
          const duplicate = seen.has(el.SalesRepName);
          seen.add(el.SalesRepName);
          return !duplicate;
        }
      });
      const sortTeamReps = sortData(filteredArr, 'SalesRepName');
      sortTeamReps.unshift({ SalesRepName: 'NONE' });
      this.setState({
        coverReps: sortTeamReps
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getCustomerNo = async (name) => {
    try {
      const customerNoRes = await getCustomerNoByName(name);

      this.setState({
        customerNo: customerNoRes.CustomerNo
      });

      if (typeof customerNoRes !== 'undefined' && customerNoRes !== null) {
        if (customerNoRes.UseCustCaseID === '1') {
          this.setState({
            hospitalUseCustCaseIDStatus: true
          });
        } else {
          this.setState({
            hospitalUseCustCaseIDStatus: false
          });
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getSideType = async () => {
    try {
      const sideTypeRes = await getSideType();
      const sortSideType = sortData(sideTypeRes, 'OptionName');
      const sideSortByNoneRes = await getNoneAtTop(sortSideType, 'OptionName');
      this.setState({
        sides: sideSortByNoneRes
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getGenderType = async () => {
    try {
      const genderTypeRes = await getGenderType();
      const sortGenderType = sortData(genderTypeRes, 'OptionName');
      const genderSortByNoneRes = await getNoneAtTop(sortGenderType, 'OptionName');
      this.setState({
        genders: genderSortByNoneRes
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getHeightUnitType = async () => {
    try {
      const heightTypeRes = await getHeightUnitType();
      const sortHeightType = sortData(heightTypeRes, 'OptionName');
      this.setState({
        heightUnitType: sortHeightType
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getWeightUnitType = async () => {
    try {
      const weightTypeRes = await getWeightUnitType();
      const sortWeightType = sortData(weightTypeRes, 'OptionName');
      this.setState({
        weightUnitType: sortWeightType
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getById = async () => {
    try {
      const {
        dispatch, params: { id }, user: { name }, tableName
      } = this.props;

      const caseRes = await getTableCaseByCaseId(id, tableName);
      if (caseRes && caseRes.ACMCaseID !== null && caseRes.CreateRep === 'ACM') {
        if (caseRes.CaseStatus === 'CANCEL') {
          this.acmCaseCancelModal.show();
        } else {
          if (caseRes.ACMCx === '1' && caseRes.CaseStatus === 'ACTIVE') {
            this.acmCaseEditNotifyModal.show();
          } else {
            this.acmCaseEditNotifyModal.show();
          }
        }
      }

      // Get case time
      const currentDate = new Date();
      const timeValues = caseRes.CaseTime.split(':');
      // const CaseDateTime = currentDate.setHours(timeValues[0], timeValues[1]);
      let CaseDateTime;
      let NewTime;
      if (timeValues.length === 2) {
        CaseDateTime = currentDate.setHours(timeValues[0], timeValues[1]);
        NewTime = new Date(CaseDateTime);
      } else {
        CaseDateTime = caseRes.CaseTime;
        NewTime = new Date(CaseDateTime);
      }

      const newCoverRep = (caseRes.CoverRep === null) ? name : caseRes.CoverRep;
      if (Object.keys(caseRes).length > 0) {
        this._getHospital(caseRes.SurgeonName);
        this.setState({
          selectedCaseId: (caseRes.ACMCaseID === null) ? caseRes.RepCaseNo : `${`${caseRes.RepCaseNo}(ACM)`}`,
          selectedType: caseRes.CaseType,
          selectedAltCaseType: caseRes.AltCaseType,
          selectedSurgeon: caseRes.SurgeonName,
          selectedHospital: caseRes.CustomerName,
          selectedProcedure: caseRes.ProcedureType,
          selectedSide: caseRes.Side,
          selectedCaseTime: NewTime,
          selectedGender: caseRes.Gender,
          selectedCoverRep: caseRes.CoverRep === null ? name : caseRes.CoverRep,
          selectedCaseDate: new Date(caseRes.CaseDate.replace(/-/g, '/')),
          customerNo: caseRes.CustomerNo,
          RepNotes: caseRes.RepNotes,
          Comments: caseRes.Comments,
          selectedHeightUnit: caseRes.HeightUnits,
          selectedWeightUnit: caseRes.WeightUnits,
        }, () => {
          this.setState({ fixCaseData: { ...caseRes, ...this.state } });
        });
        Object.keys(caseRes).map((key) => {
          if (key === 'RepCaseNo' && caseRes.ACMCaseID !== null) {
            const RepCaseNo = `${`${caseRes.RepCaseNo} (ACM)`}`;
            caseRes.RepCaseNo = RepCaseNo;
          }
          if (key === 'CaseNo') {
            caseRes.CaseNo = caseRes.CaseNo === null ? 'PENDING' : caseRes.CaseNo;
          }
          dispatch(change('EditManageCaseForm', key, caseRes[key]));
        });
        this.setState({ caseData: caseRes, manageCaseData: { ...caseRes }, newCoverRep });
      }

      if (typeof caseRes.CustomerNo !== 'undefined' && caseRes.CustomerNo !== null) {
        const hosptalRes = await getHospitalByCustomerNo(caseRes.CustomerNo);

        if (hosptalRes.UseCustCaseID === '1') {
          this.setState({
            hospitalUseCustCaseIDStatus: true
          });
        } else {
          this.setState({
            hospitalUseCustCaseIDStatus: false
          });
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedCaseType = async (caseType) => {
    try {
      const { tableName, params } = this.props;
      const { selectedType, types } = this.state;
      const altCaseTypeObj = types.find((type) => type.AltCaseType === caseType);
      if (params.hasOwnProperty('id')) {
        const caseRes = await getTableCaseByCaseId(params.id, tableName);
        if (caseRes.case_sets.length > 0 && selectedType !== altCaseTypeObj.CaseType) {
          this.typeChangeConfirmationModal.show();
        }
      }
      this.setState({
        selectedType: altCaseTypeObj.CaseType,
        selectedProcedure: altCaseTypeObj.ProcedureType,
        selectedAltCaseType: altCaseTypeObj.AltCaseType,
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onTypeChanges = () => {
    try {
      const { selectedType } = this.state;
      this.setState({ selectedType });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmit = async (formData) => {
    try {
      const {
        selectedSurgeon,
        selectedType,
        selectedAltCaseType,
        selectedHospital,
        selectedCaseDate,
        selectedCoverRep,
        selectedCaseTime,
        count,
        selectedSide,
        selectedProcedure,
        selectedGender,
        caseData,
        isEdit,
        customerNo,
        manageCaseData,
        selectedHeightUnit,
        selectedWeightUnit
      } = this.state;
      const { fixCaseData: { Comments, RepNotes } } = this.state;
      const {
        goBack, setLoader, notify, online, params: { id }, dispatch, tableName,
        user: { selectedTeam, name }
      } = this.props;

      let responseJson = {};
      if (typeof caseData !== 'undefined' && typeof caseData.CaseScheduleID !== 'undefined') {
        responseJson = await listSingleCase(caseData.CaseScheduleID);
      }

      if ((selectedCaseTime === null || selectedCaseTime === '') && formData.ACMCaseID === null) {
        notify({ type: 'error', message: 'You must select a case time' });
      }

      // if (caseData && caseData.DGR === '1') {
      //   this.caseChangesNoLonger.show();
      //   setLoader(false);
      //   return;
      // }

      // Set case time based on server timezone
      const updateTime = moment(selectedCaseTime.getTime()).format('HH:mm');
      const selectedDateTime = await getSelectedDateTime(selectedCaseDate, updateTime);

      if ((selectedCaseDate === null || selectedCaseDate === '')) {
        notify({ type: 'error', message: 'You must select a case date' });
      } else if ((selectedSurgeon === null || selectedSurgeon === '') && (!isEdit || caseData.ACMCaseID === null)) {
        notify({ type: 'error', message: 'You must select a surgeon' });
      } else if ((selectedHospital === null || selectedHospital === '') && (!isEdit || caseData.ACMCaseID === null)) {
        notify({ type: 'error', message: 'You must select a hospital' });
      } else if ((selectedType === null || selectedType === '') && (!isEdit || caseData.ACMCaseID === null)) {
        notify({ type: 'error', message: 'You must select a case type' });
      } else if ((selectedProcedure === null || selectedProcedure === '') && (!isEdit || caseData.ACMCaseID === null)) {
        notify({ type: 'error', message: 'You must select a procedure type' });
      } else {
        caseData.Age = (formData.Age > 0 ? formData.Age : null);
        caseData.CaseDate = moment(selectedDateTime).format('YYYY-MM-DD');
        caseData.CaseTime = moment(selectedDateTime).format('YYYY-MM-DD') + moment(selectedDateTime).format(' HH:mm');
        caseData.CaseType = selectedType;
        caseData.AltCaseType = selectedAltCaseType;
        caseData.ChangeRep = name;
        caseData.ProcedureType = selectedProcedure;
        caseData.Comments = (Comments === null || Comments === undefined)
          ? null : Comments !== null ? Comments.charAt(0).toUpperCase() + Comments.slice(1) : '';
        caseData.CoverRep = selectedCoverRep;
        caseData.CreateRep = selectedCoverRep;
        caseData.CustomerName = selectedHospital;
        caseData.CustomerNo = customerNo;
        caseData.Gender = selectedGender;
        caseData.Height = (formData.Height === undefined || formData.Height === '') ? null : formData.Height;
        caseData.MRN = (formData.MRN === null || formData.MRN === undefined) ? null
          : formData.MRN.toUpperCase();
        caseData.PatientID = (formData.PatientID === null || formData.PatientID === undefined)
          ? null : formData.PatientID.toUpperCase();
        caseData.RepNotes = (RepNotes === undefined || RepNotes === '') ? null
          : RepNotes !== null ? RepNotes.charAt(0).toUpperCase() + RepNotes.slice(1) : '';
        caseData.RepPONumber = (formData.RepPONumber === null || formData.RepPONumber === undefined)
          ? null : formData.RepPONumber;
        caseData.Side = selectedSide;
        caseData.SurgeonName = selectedSurgeon;
        caseData.Weight = (formData.Weight === undefined || formData.Weight === '') ? null : formData.Weight;
        caseData.HeightUnits = (selectedHeightUnit !== null && selectedHeightUnit !== '' ? selectedHeightUnit.split(', ').pop() : selectedHeightUnit);
        caseData.WeightUnits = (selectedWeightUnit !== null && selectedWeightUnit !== '' ? selectedWeightUnit.split(', ').pop() : selectedWeightUnit);
        caseData.CustCaseID = (formData.CustCaseID === null || formData.CustCaseID === undefined)
          ? null : formData.CustCaseID.toUpperCase();

        if (caseData.Height !== null && (caseData.HeightUnits === null || caseData.HeightUnits === '')) {
          caseData.HeightUnits = 'IN';
        }

        if (caseData.Weight !== null && (caseData.WeightUnits === null || caseData.WeightUnits === '')) {
          caseData.WeightUnits = 'LB';
        }

        if (caseData.Height === null) {
          caseData.HeightUnits = null;
        }

        if (caseData.Weight === null) {
          caseData.WeightUnits = null;
        }

        if (!isEdit) {
          caseData.Submitted = '0';
          caseData.Synced = '0';
        }

        setLoader(true);
        if (!isEdit) {
          let modifiedCaseResData = {
            Sync: 0,
            case_products: [],
            case_dgrs: [],
            case_xrays: [],
            case_sets: []
          };
          if (online) {
            if (typeof caseData.RepNotes !== 'undefined' && caseData.RepNotes !== null && caseData.RepNotes !== '') {
              caseData.RepNotes = caseData.RepNotes.replaceAll('\r\n', '#*#');
              // caseData.RepNotes = caseData.RepNotes.replaceAll('\n', '#*#');
              // caseData.RepNotes = caseData.RepNotes.replaceAll('\r', '#*#');
              caseData.RepNotes = caseData.RepNotes.replaceAll('#*##*##*#', '\r\n');
              caseData.RepNotes = caseData.RepNotes.replaceAll('#*##*#', '\r\n');
              caseData.RepNotes = caseData.RepNotes.replaceAll('#*#', '\r\n');
            }
            if (typeof caseData.Comments !== 'undefined' && caseData.Comments !== null && caseData.Comments !== '') {
              caseData.Comments = caseData.Comments.replaceAll('\r\n', '#*#');
              // caseData.Comments = caseData.Comments.replaceAll('\n', '#*#');
              // caseData.Comments = caseData.Comments.replaceAll('\r', '#*#');
              caseData.Comments = caseData.Comments.replaceAll('#*##*##*#', '\r\n');
              caseData.Comments = caseData.Comments.replaceAll('#*##*#', '\r\n');
              caseData.Comments = caseData.Comments.replaceAll('#*#', '\r\n');
            }
            responseJson = await addCases(caseData);
            const { message, status } = responseJson;
            if (status) {
              this._onScrollToTop();
              const caseDetails = responseJson.data[0];
              modifiedCaseResData = Object.assign(modifiedCaseResData, { ...caseDetails });
              modifiedCaseResData.CaseDate = caseData.CaseDate;
              modifiedCaseResData.CaseTime = caseData.CaseTime;
              insertCaseByCaseId(modifiedCaseResData);
              // notify({ type: 'success', message });
              dispatch(reset('EditManageCaseForm'));
            } else {
              notify({ type: 'error', message });
            }
          } else {
            caseData.ACMCaseFlags = null;
            caseData.ACMCaseID = null;
            caseData.ACMChange = '0';
            caseData.ACMCxEmail = null;
            caseData.ACMIssue = '0';
            caseData.ACMOrder = '0';
            caseData.ACMPartsSent = '0';
            caseData.ACMPlannedParts = null;
            caseData.ACMSelectedParts = null;
            caseData.AppSetQty = '0';
            caseData.CaseNo = null;
            caseData.CaseScheduleID = null;
            caseData.CaseStatus = null;
            caseData.ChangedFields = null;
            caseData.DGR = '0';
            caseData.DGRBG = '0';
            caseData.DGRSignature = null;
            caseData.DGRUpload = '0';
            caseData.DGRViewed = '0';
            caseData.DateDeleted = null;
            caseData.DateModified = null;
            caseData.Deleted = '0';
            caseData.MultiProdRep = '0';
            caseData.NoProducts = '0';
            caseData.OfficeName = null;
            caseData.ProdNotesViewed = '0';
            caseData.ProductNotes = null;
            caseData.ProductSubmitted = null;
            caseData.RepCaseNo = null;
            caseData.SalesRepName = selectedTeam.name;
            caseData.SalesRepNo = null;
            caseData.SetQty = null;
            caseData.SubOfficeName = null;
            caseData.SubmitDate = null;
            caseData.Submitted = '0';
            caseData.SurgeonNo = null;
            caseData.SurgeonNotes = null;
            caseData.Synced = '0';
            caseData.ViewShipTo = '0';

            const caseDetails = Object.assign(modifiedCaseResData, { ...caseData });
            caseDetails.Sync = 1;
            insertCaseByCaseId(caseDetails);
            this._onScrollToTop();
            dispatch(reset('EditManageCaseForm'));
          }
          this.setState({
            count: count + 1,
            selectedSide: '',
            selectedGender: '',
            RepNotes: '',
            Comments: '',
            selectedHeightUnit: '',
            selectedWeightUnit: ''
          });
          setLoader(false);
        } else if (online) {
          const {
            CaseScheduleID, AltCaseType, CaseDate, CaseTime, CustomerNo, CustomerName, SurgeonName,
            PatientID, ProcedureType, CaseType, Side, ProductNotes, Synced,
            ProductSubmitted, RepPONumber, Submitted, CoverRep, ChangeRep, DGRUpload,
            MRN, Gender, Age, ACMPlannedParts, ACMSelectedParts, Height, Weight, selectedSets,
            HeightUnits, WeightUnits, CustCaseID,
            ...partialObject
          } = caseData;

          const subset = {
            CaseScheduleID,
            AltCaseType,
            CaseDate,
            CaseTime,
            CustomerNo,
            CustomerName,
            SurgeonName,
            PatientID,
            ProcedureType,
            CaseType,
            Side,
            Comments,
            RepNotes,
            ProductNotes,
            ProductSubmitted,
            RepPONumber,
            Submitted,
            CoverRep,
            ChangeRep: name,
            DGRUpload,
            MRN,
            Gender,
            Age,
            ACMPlannedParts,
            ACMSelectedParts,
            Height,
            Weight,
            Synced,
            selectedSets,
            HeightUnits,
            WeightUnits,
            CustCaseID
          };

          if (typeof responseJson.status !== 'undefined' && responseJson.status && responseJson.hasOwnProperty('data')) {
            const caseDetails = responseJson.data[0];
            subset.Synced = caseDetails.Synced;
          }

          const compareValue = await this.compareUpdatedValue(manageCaseData, subset);
          if (compareValue) {
            subset.Submitted = '0';
            subset.Synced = (subset.Synced === '1' ? '0' : subset.Synced);
          }

          if (JSON.stringify(manageCaseData.CaseType) === JSON.stringify(selectedType)) {
            const newArrayOfObj = partialObject.case_sets.map(({
              CasePlanId: CasePlanID,
              ...rest
            }) => ({
              CasePlanID,
              ...rest
            }));
            subset.selectedSets = newArrayOfObj;
          } else {
            subset.selectedSets = [];
          }

          if (typeof subset.RepNotes !== 'undefined' && subset.RepNotes !== null && subset.RepNotes !== '') {
            subset.RepNotes = subset.RepNotes.replaceAll('\r\n', '#*#');
            // subset.RepNotes = subset.RepNotes.replaceAll('\n', '#*#');
            // subset.RepNotes = subset.RepNotes.replaceAll('\r', '#*#');
            subset.RepNotes = subset.RepNotes.replaceAll('#*##*##*#', '\r\n');
            subset.RepNotes = subset.RepNotes.replaceAll('#*##*#', '\r\n');
            subset.RepNotes = subset.RepNotes.replaceAll('#*#', '\r\n');
          }

          if (typeof subset.Comments !== 'undefined' && subset.Comments !== null && subset.Comments !== '') {
            subset.Comments = subset.Comments.replaceAll('\r\n', '#*#');
            // subset.Comments = subset.Comments.replaceAll('\n', '#*#');
            // subset.Comments = subset.Comments.replaceAll('\r', '#*#');
            subset.Comments = subset.Comments.replaceAll('#*##*##*#', '\r\n');
            subset.Comments = subset.Comments.replaceAll('#*##*#', '\r\n');
            subset.Comments = subset.Comments.replaceAll('#*#', '\r\n');
          }

          await updateCase(subset);
          setLoader(false);
          responseJson = await listSingleCase(caseData.CaseScheduleID);
          const { message, status } = responseJson;

          if (status && responseJson.hasOwnProperty('data')) {
            this._onScrollToTop();
            const caseDetails = responseJson.data[0];
            caseDetails.id = parseInt(id, 10);
            caseDetails.CaseDate = caseData.CaseDate;
            caseDetails.CaseTime = moment(caseData.CaseTime).format('HH:mm');

            updateTableWiseCaseByCaseId(caseDetails.RepCaseNo, caseDetails, tableName);
            if (tableName !== 'Cases') {
              const getCaseByCaseId = await getCaseByCaseScheduleID(caseDetails.CaseScheduleID);

              if (getCaseByCaseId !== undefined) {
                caseDetails.id = getCaseByCaseId.id;
                await updateCaseByCaseScheduleID(
                  caseDetails.CaseScheduleID, caseDetails
                );
              }
            }
            onGoBack(goBack);
          } else {
            notify({ type: 'error', message });
          }
        } else {
          caseData.Sync = 1;
          caseData.Synced = (caseData.Synced === '1' ? '0' : caseData.Synced);
          updateCaseByPrimaryId(caseData.id, caseData);
          this._onScrollToTop();
          this.setState({
            count: count + 1
          });
          setLoader(false);
          onGoBack(goBack);
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  compareUpdatedValue = async (oldValue, newValue) => {
    const { hospitalUseCustCaseIDStatus } = this.state;
    const {
      CaseScheduleID, AltCaseType, CaseDate, CaseTime, CustomerNo, CustomerName, SurgeonName,
      PatientID, ProcedureType, CaseType, Side, ProductNotes, Comments,
      ProductSubmitted, RepPONumber, CoverRep, DGRUpload,
      MRN, Gender, Age, ACMPlannedParts, ACMSelectedParts, Height, Weight, CustCaseID
    } = oldValue;
    const { selectedSets, ...newValueRest } = newValue;
    const {
      user: { name }
    } = this.props;

    delete newValueRest.RepNotes;
    delete newValueRest.Submitted;
    delete newValueRest.Synced;
    delete newValueRest.WeightUnits;
    delete newValueRest.HeightUnits;

    newValueRest.CaseTime = moment(newValueRest.CaseTime).format('HH:mm');
    newValueRest.PatientID = (typeof newValueRest.PatientID !== 'undefined' && newValueRest.PatientID !== null ? newValueRest.PatientID.toLowerCase() : newValueRest.PatientID);

    const subset = {
      CaseScheduleID,
      AltCaseType,
      CaseDate,
      CaseTime,
      CustomerNo,
      CustomerName,
      SurgeonName,
      PatientID: (typeof PatientID !== 'undefined' && PatientID !== null ? PatientID.toLowerCase() : PatientID),
      ProcedureType,
      CaseType,
      Side,
      Comments,
      ProductNotes,
      ProductSubmitted,
      RepPONumber,
      CoverRep,
      ChangeRep: name,
      DGRUpload,
      MRN,
      Gender,
      Age,
      ACMPlannedParts,
      ACMSelectedParts,
      Height,
      Weight,
      CustCaseID
    };

    if (!hospitalUseCustCaseIDStatus) {
      delete newValueRest.CustCaseID;
      delete subset.CustCaseID;
    }

    if (JSON.stringify(newValueRest) === JSON.stringify(subset)) {
      return false;
    }
    return true;
  }

  _onChangeRepNote = (key, value) => {
    try {
      const { fixCaseData } = this.state;
      fixCaseData[key] = value;
      this.setState({
        fixCaseData
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeOfficeNote = (key, value) => {
    try {
      const { fixCaseData } = this.state;
      fixCaseData[key] = value;
      this.setState({
        fixCaseData
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onBackCancel = () => {
    try {
      const { goBack } = this.props;
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getFormFieldData = (formData) => {
    try {
      const fields = [
        'selectedCaseDate',
        'selectedCaseTime',
        'RepCaseNo',
        'selectedSurgeon',
        'selectedProcedure',
        'selectedSide',
        'selectedCoverRep',
        'Height',
        'selectedHospital',
        'selectedType',
        'PatientID',
        'MRN',
        'Age',
        'selectedGender',
        'Weight',
        'RepPONumber',
        'RepNotes',
        'Comments',
        'selectedHeightUnit',
        'selectedWeightUnit'
      ];
      const caseDetail = {};
      fields.map((key) => {
        caseDetail[key] = (!formData.hasOwnProperty(key) || formData[key] === '') ? null : formData[key];
      });
      return caseDetail;
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCaseGoBack = async () => {
    try {
      const { goBack, formData, dispatch } = this.props;
      const { fixCaseData, isEdit } = this.state;
      const updatedFormData = this._getFormFieldData(
        { ...formData.values, ...this.state }
      );
      const fixFormData = this._getFormFieldData(fixCaseData);
      if (updatedFormData.RepCaseNo !== null) {
        const removeString = updatedFormData.RepCaseNo.split('(ACM)');
        Object.keys(updatedFormData).map((key) => {
          if (key === 'RepCaseNo' && updatedFormData.RepCaseNo.includes('(ACM)')) {
            const RepCaseNo = updatedFormData.RepCaseNo.replace(
              updatedFormData.RepCaseNo, trim(removeString[0])
            );
            updatedFormData.RepCaseNo = RepCaseNo;
          }
          dispatch(change('EditManageCaseForm', key, updatedFormData[key]));
        });
      }
      this.setState({ updatedFormData: { ...updatedFormData } });
      if (JSON.stringify(fixFormData) === JSON.stringify(updatedFormData)) {
        onGoBack(goBack);
      } else {
        // onGoBack(goBack);
        isEdit ? this.manageCaseBackModal.show() : onGoBack(goBack);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSaveChanges = () => {
    try {
      const { formData } = this.props;
      this._onSubmit(formData.values);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onScrollToTop = () => {
    try {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onOpenChooseFieldPage = (field) => {
    try {
      this.setState({
        fieldPageToShow: field,
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFieldSelected = async (field, value) => {
    const {
      selectedHospital, selectedType
    } = this.state;

    if (field === 'Surgeon') {
      this.setState({
        selectedSurgeon: value,
      }, async () => {
        const availableHospitals = await this._getHospital(value);
        const isIncluded = availableHospitals
          .find((hospital) => hospital.CustomerName === selectedHospital);
        if (selectedHospital) {
          if (isIncluded) {
            this.setState({
              fieldPageToShow: null,
            });
            return;
          }
          this.setState({
            selectedHospital: '',
            fieldPageToShow: null,
          }, () => {
            setTimeout(() => this._onOpenChooseFieldPage('Hospital'), 750);
          });
          return;
        }
        this._onOpenChooseFieldPage('Hospital');
      });
    }

    if (field === 'Hospital') {
      this.setState({
        selectedHospital: value,
      }, async () => {
        await this._getCustomerNo(value);
        if (selectedType) {
          this.setState({
            fieldPageToShow: null,
          });
          return;
        }
        this._onOpenChooseFieldPage('Type');
      });
    }

    if (field === 'Type') {
      await this._onSelectedCaseType(value);
      this.setState({
        fieldPageToShow: null,
      });
    }

    if (field === 'Side') {
      if (value === 'NONE') {
        this.setState({
          selectedSide: null,
          fieldPageToShow: null,
        });
        return;
      }
      this.setState({
        fieldPageToShow: null,
        selectedSide: value
      });
    }

    if (field === 'CoverRep') {
      this.setState({
        fieldPageToShow: null,
        selectedCoverRep: value
      }, () => {
        this._getTeamReps(value);
      });
    }

    if (field === 'Gender') {
      this.setState({
        fieldPageToShow: null,
        selectedGender: value === 'NONE' ? '' : value
      });
    }

    if (field === 'HeightUnitType') {
      this.setState({
        fieldPageToShow: null,
        selectedHeightUnit: value
      });
    }

    if (field === 'WeightUnitType') {
      this.setState({
        fieldPageToShow: null,
        selectedWeightUnit: value
      });
    }
  }

  _onGetObjectsList = (fieldPageToShow) => {
    const {
      surgeons, hospitals, types, sides,
      coverReps, genders, heightUnitType, weightUnitType,
    } = this.state;

    if (fieldPageToShow === 'Surgeon') {
      return surgeons.map((surgeon) => surgeon.SurgeonName);
    }

    if (fieldPageToShow === 'Hospital') {
      return hospitals.map((hospital) => hospital.CustomerName);
    }

    if (fieldPageToShow === 'Type') {
      return types.map((value) => (value.AltCaseType));
    }

    if (fieldPageToShow === 'Side') {
      return sides.map((value) => (value.OptionName));
    }

    if (fieldPageToShow === 'CoverRep') {
      return coverReps.map((value) => value.SalesRepName);
    }

    if (fieldPageToShow === 'Gender') {
      return genders.map((value) => value.OptionName);
    }

    if (fieldPageToShow === 'HeightUnitType') {
      return heightUnitType.map((value) => value.OptionName);
    }

    if (fieldPageToShow === 'WeightUnitType') {
      return weightUnitType.map((value) => value.OptionName);
    }

    return [];
  }

  _acmBackCall = () => {
    try {
      const {
        params: { id }, goBack
      } = this.props;

      onGoBack(goBack);
      browserHistory.push(`/manage-case/${id}`);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeUpdate = (event) => {
    try {
      const {
        isEdit,
        selectedHeightUnit,
        selectedWeightUnit
      } = this.state;
      const field = event.target.name;
      const fieldValue = event.target.value;

      if (field === 'Height') {
        if (fieldValue === '') {
          this.setState({ selectedHeightUnit: '' });
        } else {
          if (isEdit) {
            if (selectedHeightUnit === null || selectedHeightUnit === '') {
              this.setState({ selectedHeightUnit: 'IN' });
            }
          } else {
            if (selectedHeightUnit === null || selectedHeightUnit === '') {
              this.setState({ selectedHeightUnit: 'IN' });
            }
          }
        }
      }

      if (field === 'Weight') {
        if (fieldValue === '') {
          this.setState({ selectedWeightUnit: '' });
        } else {
          if (isEdit) {
            if (selectedWeightUnit === null || selectedWeightUnit === '') {
              this.setState({ selectedWeightUnit: 'LB' });
            }
          } else {
            if (selectedWeightUnit === null || selectedWeightUnit === '') {
              this.setState({ selectedWeightUnit: 'LB' });
            }
          }
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const {
        params, selectCaseDate, user, dispatch
      } = this.props;

      dispatch(change('EditManageCaseForm', 'CustCaseID', ''));
      dispatch(change('EditManageCaseForm', 'PatientID', ''));
      dispatch(change('EditManageCaseForm', 'MRN', ''));
      dispatch(change('EditManageCaseForm', 'Age', ''));
      dispatch(change('EditManageCaseForm', 'Height', ''));
      dispatch(change('EditManageCaseForm', 'Weight', ''));
      dispatch(change('EditManageCaseForm', 'RepPONumber', ''));

      this._onScrollToTop();
      if (params.hasOwnProperty('id')) {
        this.setState({ isEdit: true });
        await this._getSurgeon();
        await this._getById();
      } else {
        this.setState({ selectedCoverRep: user.name });
        this.setState({ selectedCaseDate: new Date(selectCaseDate) });
      }
      await this._getSurgeon();
      await this._getCaseType();
      await this._getProcedureTypes();
      await this._getTeamReps();
      await this._getSideType();
      await this._getGenderType();
      await this._getHeightUnitType();
      await this._getWeightUnitType();
      $(document).on('focus', '.select2-selection.select2-selection--single', function () {
        $(this).closest('.select2-container').siblings('select:enabled').select2('open');
      });

      // steal focus during close - only capture once and stop propogation
      $('select.select2').on('select2:closing', (e) => {
        $(e.target).data('select2').$selection.one('focus focusin', (ee) => {
          ee.stopPropagation();
        });
      });
      $('select').select2({
        minimumResultsForSearch: -1
      })
        .on('select2-opening', function () {
          $(this).siblings('.select2-container').find('.select2-search, .select2-focusser').remove();
        });
      $('select').on('select2:open', () => {
        $('.select2-search__field').remove();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      handleSubmit,
      online,
      formData
    } = this.props;
    const {
      caseData,
      selectedAltCaseType,
      selectedType,
      selectedProcedure,
      selectedSurgeon,
      selectedHospital,
      selectedSide,
      selectedGender,
      isEdit,
      selectedCaseDate,
      selectedCoverRep,
      count,
      selectedCaseTime,
      fixCaseData,
      newCoverRep,
      timeConstraints,
      fieldPageToShow,
      selectedHeightUnit,
      selectedWeightUnit,
      hospitalUseCustCaseIDStatus,
    } = this.state;

    return (
      <div>
        {
          !fieldPageToShow ? (
            <form onSubmit={handleSubmit(this._onSubmit)} name="EditManageCaseForm" className="resizer-class">
              <Header
                actionButton={(isEdit === true) ? { title: 'Save' } : { title: 'Add' }}
                title={(isEdit === true) ? 'Edit Case Details' : 'Add Case'}
                goBack={() => this._onCaseGoBack()}
              />
              <section className="case-details-section caseDetailsSection">
                <div className="container">
                  {
                    (isEdit !== true)
                      ? (
                        <div className="textPrimary" style={{ color: '#eda340', fontWeight: 600 }}>
                          <label htmlFor="text">Cases Added: &nbsp; {count}</label>
                        </div>
                      ) : ''
                  }
                  <div className="row gx-2">
                    {
                      (isEdit)
                        ? (
                          <div className="col-12">
                            <div className="case-data">
                              <label htmlFor="case_id">Case ID</label>
                              <Field
                                type="text"
                                name="CaseNo"
                                className="form-control"
                                // placeholder={selectedCaseId}
                                component={renderField}
                                disabled
                              />
                            </div>
                          </div>
                        ) : ''
                    }

                    {
                      (isEdit && hospitalUseCustCaseIDStatus)
                        ? (
                          <div className="col-12">
                            <div className="case-data">
                              <label htmlFor="CustCaseID">Customer Case ID</label>
                              <Field
                                type="text"
                                name="CustCaseID"
                                className="form-control"
                                component={renderField}
                                validate={maxLength50}
                                disabled={caseData.DGR === '1' ? true : (!online && (isEdit ? !online : online))}
                              />
                            </div>
                          </div>
                        ) : ''
                    }

                    <div className="col-6 col-md-6">
                      <div className="case-data">
                        <label htmlFor="date">Date</label>
                        <DatePicker
                          dateFormat="E MMM d, y"
                          className="form-control"
                          id="date-picker-input"
                          // placeholderText="Start Date"
                          selected={selectedCaseDate}
                          onChange={(value) => {
                            this.setState({ selectedCaseDate: value });
                          }}
                          onChangeRaw={(e) => {
                            e.preventDefault();
                          }}
                          disabled={caseData.DGR === '1' ? true : (!online && (isEdit ? !online : online))}
                        />
                      </div>
                    </div>

                    <div className="col-6 col-md-6">
                      <div className="case-data">
                        <label htmlFor="time">Time</label>
                        <Datetime
                          dateFormat={false}
                          onChange={(value) => {
                            this.setState({ selectedCaseTime: value._d });
                          }}
                          className="time-border"
                          inputProps={{
                            id: 'date-picker-input2',
                            disabled: (caseData.DGR === '1' ? true : !online && (isEdit ? !online : online))
                          }}
                          timeConstraints={timeConstraints}
                          // className="time-picker"
                          value={selectedCaseTime}
                          disabled={caseData.DGR === '1' ? true : (!online && (isEdit ? !online : online))}
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="case-data">
                        <label htmlFor="surgeon">Surgeon*</label>
                        <input
                          id="surgeon"
                          className="form-control text-uppercase"
                          value={selectedSurgeon}
                          onChange={() => { }}
                          onFocus={() => this._onOpenChooseFieldPage('Surgeon')}
                          disabled={caseData.DGR === '1' ? true : (caseData.ACMCaseID !== null && caseData.CreateRep === 'ACM' && isEdit)
                            || (!online && (isEdit ? !online : online))}
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="case-data">
                        <label htmlFor="hospital">Hospital*</label>
                        <input
                          id="hospital"
                          className="form-control text-uppercase"
                          value={selectedHospital}
                          onChange={() => { }}
                          onFocus={() => this._onOpenChooseFieldPage('Hospital')}
                          disabled={caseData.DGR === '1' ? true : (caseData.ACMCaseID !== null && caseData.CreateRep === 'ACM' && isEdit)
                            || (!online && (isEdit ? !online : online))}
                        />
                      </div>
                    </div>

                    <div className="col-8">
                      <div className="case-data">
                        <label htmlFor="type">Type*</label>
                        <input
                          id="type"
                          className="form-control text-uppercase"
                          value={selectedAltCaseType || (selectedType ? `${selectedType}, ${selectedProcedure}` : '')}
                          onChange={() => { }}
                          onFocus={() => this._onOpenChooseFieldPage('Type')}
                          disabled={caseData.DGR === '1' ? true : (!online && (isEdit ? !online : online))}
                        />
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="case-data">
                        <label htmlFor="side">Side</label>
                        <input
                          id="side"
                          className="form-control text-uppercase"
                          value={selectedSide}
                          onChange={() => { }}
                          onFocus={() => this._onOpenChooseFieldPage('Side')}
                          disabled={caseData.DGR === '1' ? true : (!online && (isEdit ? !online : online))}
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="case-data">
                        <label htmlFor="rep">Cover Rep</label>
                        <input
                          id="rep"
                          className="form-control text-uppercase"
                          value={(selectedCoverRep !== 'NONE'
                            || selectedCoverRep === newCoverRep) ? selectedCoverRep : ''}
                          onChange={() => { }}
                          onFocus={() => this._onOpenChooseFieldPage('CoverRep')}
                          disabled={caseData.DGR === '1' ? true : (!online && (isEdit ? !online : online))}
                        />
                      </div>
                    </div>

                    {
                      (!isEdit && hospitalUseCustCaseIDStatus)
                        ? (
                          <div className="col-12">
                            <div className="case-data">
                              <label htmlFor="CustCaseID">Customer Case ID</label>
                              <Field
                                type="text"
                                name="CustCaseID"
                                className="form-control"
                                component={renderField}
                                validate={maxLength50}
                                disabled={caseData.DGR === '1' ? true : (caseData.ACMCaseID !== null && caseData.CreateRep === 'ACM' && isEdit)}
                              />
                            </div>
                          </div>
                        ) : ''
                    }

                    <div className="col-12">
                      <div className="case-data">
                        <label htmlFor="PatientID">Patient</label>
                        <Field
                          type="text"
                          name="PatientID"
                          className="form-control text-uppercase"
                          // placeholder="Patientname"
                          component={renderField}
                          validate={maxLength50}
                          disabled={caseData.DGR === '1' ? true : (caseData.ACMCaseID !== null && caseData.CreateRep === 'ACM' && isEdit)}
                          onKeyDown={(evt) => ['\'', '%', '#', '*'].includes(evt.key) && evt.preventDefault()}
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="case-data">
                        <label htmlFor="MRN">MRN</label>
                        <Field
                          type="text"
                          name="MRN"
                          className="form-control text-uppercase"
                          // placeholder="0987654321-ABCD"
                          component={renderField}
                          validate={maxLength50}
                          disabled={caseData.DGR === '1' ? true : (caseData.ACMCaseID !== null && caseData.CreateRep === 'ACM' && isEdit)}
                        />
                      </div>
                    </div>

                    <div className="col-6 col-md-6">
                      <div className="case-data">
                        <label htmlFor="Age">Age</label>
                        <Field
                          type="number"
                          name="Age"
                          className="form-control"
                          // placeholder="71"
                          component={renderField}
                          validate={[maxLength3, maxValue120]}
                          disabled={caseData.DGR === '1' ? true : (caseData.ACMCaseID !== null && caseData.CreateRep === 'ACM' && isEdit)
                            || (!online && (isEdit ? !online : online))}
                          onKeyDown={(evt) => ['e', 'E', '+', '-', '.'].includes(evt.key) && evt.preventDefault()}
                        />
                      </div>
                    </div>

                    <div className="col-6 col-md-6">
                      <div className="case-data">
                        <label htmlFor="Gender">Gender</label>
                        <input
                          id="Gender"
                          className="form-control text-uppercase"
                          value={selectedGender !== 'NONE' ? selectedGender : ''}
                          onChange={() => { }}
                          onFocus={() => this._onOpenChooseFieldPage('Gender')}
                          disabled={caseData.DGR === '1' ? true : (caseData.ACMCaseID !== null && caseData.CreateRep === 'ACM' && isEdit)
                            || (!online && (isEdit ? !online : online))}
                        />

                      </div>
                    </div>

                    <div className="col-6 col-md-6 d-flex gap-2">
                      <div className="case-data w-75">
                        <label htmlFor="Height">Height</label>
                        <Field
                          type="text"
                          name="Height"
                          className="form-control"
                          // placeholder="6ft 2in"
                          component={renderField}
                          validate={maxLength25}
                          disabled={caseData.DGR === '1' ? true : (caseData.ACMCaseID !== null && caseData.CreateRep === 'ACM' && isEdit)
                            || (!online && (isEdit ? !online : online))}
                          maxLength="10"
                          onChange={(event) => this._onChangeUpdate(event)}
                        />
                      </div>

                      <div className="case-data w-25">
                        <label htmlFor="heightUnit">Units</label>
                        <input
                          id="heightUnit"
                          className="form-control text-uppercase"
                          value={(selectedHeightUnit !== null && selectedHeightUnit !== '') ? selectedHeightUnit.split(', ').pop() : ''}
                          onChange={() => { }}
                          onFocus={() => this._onOpenChooseFieldPage('HeightUnitType')}
                          disabled={caseData.DGR === '1' ? true : (caseData.ACMCaseID !== null && caseData.CreateRep === 'ACM' && isEdit)
                            || (!online && (isEdit ? !online : online))}
                        />
                      </div>
                    </div>

                    <div className="col-6 col-md-6 d-flex gap-2">
                      <div className="case-data w-75">
                        <label htmlFor="Weight">Weight</label>
                        <Field
                          type="text"
                          name="Weight"
                          className="form-control"
                          // placeholder="150 lbs"
                          component={renderField}
                          validate={maxLength25}
                          disabled={caseData.DGR === '1' ? true : (caseData.ACMCaseID !== null && caseData.CreateRep === 'ACM' && isEdit)
                            || (!online && (isEdit ? !online : online))}
                          maxLength="10"
                          onChange={(event) => this._onChangeUpdate(event)}
                        />
                      </div>

                      <div className="case-data w-25">
                        <label htmlFor="weightUnit">Units</label>
                        <input
                          id="weightUnit"
                          className="form-control text-uppercase"
                          value={(selectedWeightUnit !== null && selectedWeightUnit !== '') ? selectedWeightUnit.split(', ').pop() : ''}
                          onChange={() => { }}
                          onFocus={() => this._onOpenChooseFieldPage('WeightUnitType')}
                          disabled={caseData.DGR === '1' ? true : (caseData.ACMCaseID !== null && caseData.CreateRep === 'ACM' && isEdit)
                            || (!online && (isEdit ? !online : online))}
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="case-data">
                        <label htmlFor="RepPONumber">Rep PO#</label>
                        <Field
                          type="text"
                          name="RepPONumber"
                          className="form-control text-uppercase"
                          // placeholder="0987654321-ABCD"
                          component={renderField}
                          validate={maxLength50}
                          disabled={!online && (isEdit ? !online : online)}
                        />
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div className="row gx-2">
                    <div className="col-12">
                      <div className="case-data">
                        <label htmlFor="RepNotes">Rep Notes (not seen by office staff)</label>
                        <p className={`${isMobile ? '' : 'uc-first-letter'}`}>
                          <TextareaExpanding
                            id="repNote"
                            value={(fixCaseData.RepNotes && fixCaseData.RepNotes !== null)
                              ? fixCaseData.RepNotes.replace(/(?:\n\r|\r\n|\r|\n)/g, '\n')
                              : fixCaseData.RepNotes}
                            className="form-control uc-first-letter"
                            autoCapitalize="on"
                            onChange={(event) => this._onChangeRepNote('RepNotes', window.UCFirst(event.target.value))}
                            placeholder="Add Notes"
                            disabled={(!online && (isEdit ? !online : online))}
                          />
                        </p>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="case-data">
                        <label htmlFor="Comments">Office Notes</label>
                        <p className={`${isMobile ? '' : 'uc-first-letter'}`}>
                          <TextareaExpanding
                            id="officeNote"
                            value={(fixCaseData.Comments && fixCaseData.Comments !== null)
                              ? fixCaseData.Comments.replace(/(?:\n\r|\r\n|\r|\n)/g, '\n')
                              : fixCaseData.Comments}
                            className="form-control"
                            autoCapitalize="on"
                            onChange={(event) => this._onChangeOfficeNote('Comments', window.UCFirst(event.target.value))}
                            placeholder="Add Notes"
                            disabled={caseData.DGR === '1' ? true : (!online && (isEdit ? !online : online))}
                            onKeyDown={(evt) => ['\'', '%', '#', '*'].includes(evt.key) && evt.preventDefault()}
                          />
                        </p>
                      </div>
                    </div>

                    {
                      isEdit && (caseData.ACMCaseID !== null && caseData.CreateRep === 'ACM')
                      && (
                        <div className="col-12">
                          <div className="case-data">
                            <label htmlFor="Clinical">Clinical Notes</label>
                            <Field
                              type="textarea"
                              name="SurgeonNotes"
                              id="clinicalNote"
                              className="form-control"
                              component={renderField}
                              // onChange={this._onChangeOfficeNote}
                              disabled={caseData.DGR === '1' ? true : (caseData.ACMCaseID !== null && caseData.CreateRep === 'ACM' && isEdit)
                                || (!online && (isEdit ? !online : online))}
                            />
                          </div>
                        </div>
                      )
                    }
                  </div>
                </div>
              </section>
            </form>
          ) : (
            <ChooseFieldPage
              pageTitle={fieldPageToShow}
              onGoBack={
                () => {
                  const { values } = formData;
                  const isValidField = (field) => typeof values !== 'undefined' && typeof values[field] !== 'undefined' && values[field] !== '';

                  if (fieldPageToShow === 'HeightUnitType' && isValidField('Height')) {
                    this._onFieldSelected(fieldPageToShow, 'INCHES, IN');
                  } else if (fieldPageToShow === 'WeightUnitType' && isValidField('Weight')) {
                    this._onFieldSelected(fieldPageToShow, 'POUNDS, LB');
                  }

                  // Default action to hide the field page
                  this.setState({ fieldPageToShow: null });
                }
              }
              objectsList={this._onGetObjectsList(fieldPageToShow)}
              onSelect={(value) => this._onFieldSelected(fieldPageToShow, value)}
              hideSearch={['Gender', 'Side', 'Type', 'Procedure', 'HeightUnitType', 'WeightUnitType'].includes(fieldPageToShow)}
              caseData={caseData}
            />
          )
        }

        <AcmCaseEditNotify />
        <CaseChangesNoLonger
          id={caseData.id}
        />
        <TypeChangeConfirmationModal
          caseRes={caseData}
          onSaveChanges={this._onTypeChanges}
          editManageCase
        />
        <ACMProductGoBackModal
          onSave={this._onSaveChanges}
          onCancel={this._onBackCancel}
        />
        <AcmCaseCancel
          acmBackCall={this._acmBackCall}
        />
      </div>
    );
  }
}

const editManageCaseProps = withSelectedSetsPayload(
  withSetsListStateStorage(
    withTableName(
      withTeam(
        withOnline(
          withGoBack(
            withSelectCaseDate(
              withNotify(
                withLoader(
                  withUser(
                    EditManageCase
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);

export default compose(
  connect((state) => ({
    formData: state.form.EditManageCaseForm
  })),
  reduxForm({ form: 'EditManageCaseForm' })
)(editManageCaseProps);
